import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { ToastProvider, useToast } from '@pro-sto/ui';
import { toastStore } from '@/stores/ToastStore';
import AppRouter from '@/router';

const ToastInitializer = observer(() => {
  const { showToast } = useToast();

  useEffect(() => {
    toastStore.initialize(showToast);
  }, [showToast]);

  return null;
});

const App = observer(() => {
  return (
    <ToastProvider position="top-right" maxToasts={3}>
      <ToastInitializer />
      <div data-testid="master-admin-app">
        <AppRouter />
      </div>
    </ToastProvider>
  );
});

App.displayName = 'App';

export default App;
